/*
  Seletor de variantes do tp-product-card (snippets/tp-product-card.liquid).
  Ao escolher uma variante troca imagem, preço, badge de desconto, links e a variante enviada ao carrinho.
  Os dados de cada variante já vêm renderizados pelo Liquid (data-* no chip e <template> de preço/imagem).
  Usa delegação de eventos: funciona em slides clonados pelo Swiper e em grids recarregados por filtro.
*/
if (!window.tpProductCardVariants) {
  window.tpProductCardVariants = true;

  const SOLD_OUT_LABEL = 'Esgotado';
  const IMAGE_ATTRIBUTES = ['srcset', 'src', 'alt', 'width', 'height'];
  const ARROW_STEPS = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 };

  const findTemplate = (group, kind, key) => group.querySelector(`template[data-variant-${kind}="${key}"]`);

  const updateCart = (card, chip) => {
    const available = chip.dataset.available === 'true';
    const variantIdInput = card.querySelector('.product-variant-id');
    const submitButton = card.querySelector('.tp-product-card__form [type="submit"]');

    if (variantIdInput) variantIdInput.value = chip.dataset.variantId;
    if (!submitButton) return;

    const label = submitButton.querySelector('span');
    submitButton.disabled = !available;
    submitButton.classList.toggle('tp-button--disabled', !available);
    if (label) label.textContent = available ? submitButton.dataset.label : SOLD_OUT_LABEL;
  };

  const updatePrice = (card, group, variantId) => {
    const price = card.querySelector('.tp-price');
    const template = findTemplate(group, 'price', variantId);
    if (price && template) price.replaceChildren(template.content.cloneNode(true));
  };

  const updateDiscountBadge = (card, chip) => {
    const badge = card.querySelector('[data-tp-discount-badge]');
    if (!badge) return;

    const discount = chip.dataset.discount.trim();
    badge.textContent = discount;
    badge.hidden = !discount;
  };

  // Variante sem imagem própria volta para a imagem padrão do produto
  const updateImage = (card, group, variantId) => {
    const image = card.querySelector('.tp-image--main');
    const template = findTemplate(group, 'image', variantId) || findTemplate(group, 'image', 'default');
    const source = template && template.content.querySelector('img');
    if (!image || !source) return;

    IMAGE_ATTRIBUTES.forEach((name) => {
      const value = source.getAttribute(name);
      if (value !== null) image.setAttribute(name, value);
    });
  };

  const updateLinks = (card, chip) => {
    card.querySelectorAll('a.tp-product-card__link, a.tp-button').forEach((link) => {
      link.href = chip.dataset.url;
    });
  };

  const selectVariant = (chip) => {
    const card = chip.closest('.tp-product-card');
    const group = chip.closest('.tp-product-card__variants');
    if (!card || !group) return;

    group.querySelectorAll('.tp-product-card__variant').forEach((item) => {
      const isSelected = item === chip;
      item.setAttribute('aria-checked', String(isSelected));
      item.tabIndex = isSelected ? 0 : -1;
    });

    updateCart(card, chip);
    updatePrice(card, group, chip.dataset.variantId);
    updateDiscountBadge(card, chip);
    updateImage(card, group, chip.dataset.variantId);
    updateLinks(card, chip);
  };

  document.addEventListener('click', (event) => {
    const chip = event.target.closest('.tp-product-card__variant');
    if (chip) selectVariant(chip);
  });

  document.addEventListener('keydown', (event) => {
    const chip = event.target.closest('.tp-product-card__variant');
    const step = ARROW_STEPS[event.key];
    if (!chip || !step) return;

    event.preventDefault();
    const chips = [...chip.closest('.tp-product-card__variant-list').querySelectorAll('.tp-product-card__variant')];
    const next = chips[(chips.indexOf(chip) + step + chips.length) % chips.length];
    next.focus();
    selectVariant(next);
  });
}
